import en from './en';
import ar from './ar';
import ru from './ru';

export default {en, ar, ru};
